import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { Item } from './item.model';
import { ResponseWrapper, createRequestOption } from '../../shared';
import { API } from '../../shared/constants/api.constants';

@Injectable()
export class ItemService {
    private resourceUrlGetFooterInfo = API.host + 'InvoicePortal/portal-get-footer-info';
    private resourceUrlGetHidedSign = API.host + 'InvoicePortal/hide-sign';

    constructor(
        private http: Http
    ) { }

    getFooterInfo(): Observable<ResponseWrapper> {
        return this.http.get(this.resourceUrlGetFooterInfo)
            .map((res: Response) => this.convertResponse(res));
    }

    getHidedSign() {
        let callAPI = this.http
        .get(`${this.resourceUrlGetHidedSign}`)
        .map((res: any) => {
            if (!res || !res.json) {
                throw 'Invalid Code';
            }
            return res.json().data;
        });
        return callAPI;
    }

    private convertResponse(res: Response): any {
        if (!res || !res.json) {
            throw 'Invalid Code';
        }

        const jsonResponse = res.json().data;
        return new ResponseWrapper(res.headers, jsonResponse, res.status);
    }

    private convert(item: Item): Item {
        const copy: Item = Object.assign({}, item);
        return copy;
    }
}
